import { t } from "ttag";

import { POST_MEETING_STATUS } from "@/features/consultations/models";
import type { Appointment } from "@/features/consultations/models";
import { formatDate, formatTime } from "@/shared/lib";
import { EmptyState, icons, IconWrapper, Table } from "@/shared/ui";
import { tw } from "@/shared/utils";

interface PastConsultationsTableProps {
  consultations: Appointment[];
  setDocumentId: (documentId: Appointment["documentId"]) => void;
}

export const PastConsultationsTable = ({
  consultations,
  setDocumentId,
}: PastConsultationsTableProps) => {
  return (
    <Table.Root>
      <Table.Header>
        <Table.Row>
          <Table.Head>{t`Provider`}</Table.Head>
          <Table.Head>{t`Date`}</Table.Head>
          <Table.Head>{t`Time`}</Table.Head>
          <Table.Head className="w-44">{t`Status`}</Table.Head>
          <Table.Head className="w-24">{t`Notes`}</Table.Head>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {consultations.length ? (
          consultations.map((consultation) => (
            <Table.Row key={`past-consultation-${consultation.id}`}>
              <Table.Cell>{consultation.provider?.fullName ?? "-"}</Table.Cell>
              <Table.Cell>{formatDate(consultation.startTime)}</Table.Cell>
              <Table.Cell>
                {`${formatTime(consultation.startTime)} - ${formatTime(consultation.endTime)}`}
              </Table.Cell>
              <Table.Cell
                className={tw(
                  "font-semibold",
                  consultation.pmStatus === POST_MEETING_STATUS.CANCELLED &&
                    "text-red-700",
                )}
              >
                {consultation.pmStatus}
              </Table.Cell>
              <Table.Cell>
                {consultation.documentId && (
                  <IconWrapper
                    size="xl"
                    className="cursor-pointer rounded-full p-2"
                  >
                    <icons.Document
                      onClick={() => setDocumentId(consultation.documentId)}
                    />
                  </IconWrapper>
                )}
              </Table.Cell>
            </Table.Row>
          ))
        ) : (
          <Table.Row className="pointer-events-none">
            <Table.Cell colSpan={5}>
              <EmptyState.Root className="border-none">
                <EmptyState.Icon />
                <EmptyState.Description>
                  {t`You haven't had any consultation yet`}
                </EmptyState.Description>
              </EmptyState.Root>
            </Table.Cell>
          </Table.Row>
        )}
      </Table.Body>
    </Table.Root>
  );
};
